__turbopack_context__.v({
  "body": "PriorityMessageDrawer-module-scss-module__XbRJIq__body",
  "slide": "PriorityMessageDrawer-module-scss-module__XbRJIq__slide",
  "track": "PriorityMessageDrawer-module-scss-module__XbRJIq__track",
  "viewport": "PriorityMessageDrawer-module-scss-module__XbRJIq__viewport",
});
